var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpNonAttive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.96,
    height: 20.96,
    viewBox: "0 0 20.96 20.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-active-3419311",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9571",
    "data-name": "Tracciato 9571",
    d: "M16.48,6A10.48,10.48,0,1,0,26.96,16.48,10.48,10.48,0,0,0,16.48,6Zm0,19.348a8.868,8.868,0,1,1,8.868-8.868,8.868,8.868,0,0,1-8.868,8.868Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9572",
    "data-name": "Tracciato 9572",
    d: "M30.846,18a.812.812,0,0,0-.846.772v9.262a.85.85,0,0,0,1.692,0V18.772A.812.812,0,0,0,30.846,18Z",
    transform: "translate(-14.366 -6.923)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpNonAttive);
export default __webpack_public_path__ + "static/media/OpNonAttive.f2b64db1239c6e0ca066faa48d564a8d.svg";
export { ForwardRef as ReactComponent };